import { debounce, QInput, QIcon, QBtn } from "quasar";
import { defineComponent, ref, onMounted, createElementBlock, openBlock, createElementVNode, createCommentVNode, nextTick, Fragment, computed, normalizeClass, watchEffect, createVNode, withCtx, createBlock, toDisplayString } from "vue";
import { SocialLinkUtils } from "@utils/string-utils";
import { useI18n } from "vue-i18n";
const _sfc_main$7 = /* @__PURE__ */ defineComponent({
  __name: "facebook-embed",
  props: {
    postUrl: { type: String, required: true, default: "" },
    embedType: { type: String, required: true, default: "" }
  },
  setup(__props, { expose: __expose }) {
    __expose();
    const sharedStore = ref({
      scriptLoaded: false
    });
    const loadScript = () => {
      const scriptElem = document.createElement("script");
      scriptElem.src = "https://connect.facebook.net/de_DE/sdk.js#xfbml=1&version=v7.0";
      scriptElem.crossOrigin = "anonymous";
      scriptElem.defer = true;
      document.body.appendChild(scriptElem);
      sharedStore.value.scriptLoaded = true;
    };
    onMounted(() => {
      if (sharedStore.value.scriptLoaded) {
        window.FB.XFBML.parse();
      } else {
        delete window.FB;
        loadScript();
      }
    });
    const __returned__ = { sharedStore, loadScript };
    Object.defineProperty(__returned__, "__isScriptSetup", { enumerable: false, value: true });
    return __returned__;
  }
});
const _export_sfc = (sfc, props) => {
  const target = sfc.__vccOpts || sfc;
  for (const [key, val] of props) {
    target[key] = val;
  }
  return target;
};
const _hoisted_1$7 = { class: "mb-8" };
const _hoisted_2$5 = ["data-href"];
const _hoisted_3$3 = ["data-href"];
function _sfc_render$7(_ctx, _cache, $props, $setup, $data, $options) {
  return openBlock(), createElementBlock("div", _hoisted_1$7, [
    _cache[0] || (_cache[0] = createElementVNode(
      "div",
      { id: "fb-root" },
      null,
      -1
      /* CACHED */
    )),
    $props.embedType === "posts" ? (openBlock(), createElementBlock("div", {
      key: 0,
      class: "fb-post",
      "data-href": $props.postUrl
    }, null, 8, _hoisted_2$5)) : createCommentVNode("v-if", true),
    $props.embedType === "videos" || $props.embedType === "reel" ? (openBlock(), createElementBlock("div", {
      key: 1,
      class: "fb-video",
      "data-href": $props.postUrl,
      "data-width": "500",
      "data-allowfullscreen": "true",
      "data-autoplay": "false",
      "data-show-captions": "true"
    }, null, 8, _hoisted_3$3)) : createCommentVNode("v-if", true)
  ]);
}
const FacebookEmbed = /* @__PURE__ */ _export_sfc(_sfc_main$7, [["render", _sfc_render$7], ["__file", "/builds/CT/content-technology-framework/modules/social/editor-ui/src/embeds/facebook-embed.vue"]]);
const _sfc_main$6 = /* @__PURE__ */ defineComponent({
  __name: "instagram-embed",
  props: {
    postId: { type: String, required: true, default: "" },
    postType: { type: String, required: true, default: "" }
  },
  setup(__props, { expose: __expose }) {
    __expose();
    const props = __props;
    const sharedStore = ref({
      scriptLoaded: false,
      scriptLoading: false
    });
    const html = ref("");
    const generteEmbed = async () => {
      html.value = `
          <blockquote class="instagram-media"
                      data-instgrm-permalink="https://www.instagram.com/${props.postType}/${props.postId}/?utm_source=ig_embed&amp;utm_campaign=loading"
                      data-instgrm-version="14">
            <a href="https://www.instagram.com/${props.postType}/${props.postId}/?utm_source=ig_embed&amp;utm_campaign=loading" target="_blank"></a>
          </blockquote>`;
      await nextTick(() => {
        sharedStore.value.scriptLoading = false;
        sharedStore.value.scriptLoaded = true;
        window.instgrm.Embeds.process();
      });
    };
    const injectScript = () => {
      sharedStore.value.scriptLoading = true;
      const s = document.createElement("script");
      s.crossOrigin = "anonymous";
      s.defer = true;
      s.src = "//www.instagram.com/embed.js";
      s.onload = () => generteEmbed();
      document.body.appendChild(s);
    };
    onMounted(() => {
      injectScript();
    });
    const __returned__ = { props, sharedStore, html, generteEmbed, injectScript };
    Object.defineProperty(__returned__, "__isScriptSetup", { enumerable: false, value: true });
    return __returned__;
  }
});
const _hoisted_1$6 = { class: "instagram-embed mb-8" };
const _hoisted_2$4 = ["innerHTML"];
function _sfc_render$6(_ctx, _cache, $props, $setup, $data, $options) {
  return openBlock(), createElementBlock("div", _hoisted_1$6, [
    createCommentVNode(" eslint-disable-next-line vue/no-v-html "),
    createElementVNode("div", { innerHTML: $setup.html }, null, 8, _hoisted_2$4)
  ]);
}
const InstagramEmbed = /* @__PURE__ */ _export_sfc(_sfc_main$6, [["render", _sfc_render$6], ["__file", "/builds/CT/content-technology-framework/modules/social/editor-ui/src/embeds/instagram-embed.vue"]]);
const _sfc_main$5 = {};
const _hoisted_1$5 = { class: "flex flex-center placeholder-embed" };
function _sfc_render$5(_ctx, _cache) {
  return openBlock(), createElementBlock("div", _hoisted_1$5);
}
const PlaceholderEmbed = /* @__PURE__ */ _export_sfc(_sfc_main$5, [["render", _sfc_render$5], ["__scopeId", "data-v-aa5f62b9"], ["__file", "/builds/CT/content-technology-framework/modules/social/editor-ui/src/embeds/placeholder-embed.vue"]]);
const _sfc_main$4 = /* @__PURE__ */ defineComponent({
  __name: "tiktok-embed",
  props: {
    postUrl: { type: String, required: true, default: "" },
    postId: { type: String, required: true, default: "" },
    embedType: { type: String, required: true, default: "" },
    accountName: { type: String, required: true, default: "" }
  },
  setup(__props, { expose: __expose }) {
    __expose();
    const injectScript = () => {
      const tikTokScript = document.createElement("script");
      tikTokScript.setAttribute("src", "https://www.tiktok.com/embed.js");
      tikTokScript.setAttribute("async", "");
      tikTokScript.setAttribute("id", "tiktok-script");
      document.head.appendChild(tikTokScript);
    };
    onMounted(injectScript);
    const __returned__ = { injectScript };
    Object.defineProperty(__returned__, "__isScriptSetup", { enumerable: false, value: true });
    return __returned__;
  }
});
const _hoisted_1$4 = { class: "mb-8" };
const _hoisted_2$3 = ["cite", "data-video-id"];
const _hoisted_3$2 = ["cite", "data-unique-id"];
function _sfc_render$4(_ctx, _cache, $props, $setup, $data, $options) {
  return openBlock(), createElementBlock("div", _hoisted_1$4, [
    createCommentVNode(" video post "),
    !$props.embedType || $props.embedType === "video" ? (openBlock(), createElementBlock("blockquote", {
      key: 0,
      class: "tiktok-embed",
      cite: $props.postUrl,
      "data-video-id": $props.postId,
      style: { "max-width": "605px", "min-width": "325px" }
    }, _cache[0] || (_cache[0] = [
      createElementVNode(
        "section",
        null,
        null,
        -1
        /* CACHED */
      )
    ]), 8, _hoisted_2$3)) : (openBlock(), createElementBlock(
      Fragment,
      { key: 1 },
      [
        createCommentVNode(" photo post "),
        createElementVNode("blockquote", {
          class: "tiktok-embed",
          cite: $props.postUrl,
          "data-unique-id": $props.accountName,
          "data-embed-type": "creator",
          style: { "max-width": "605px", "min-width": "325px" }
        }, _cache[1] || (_cache[1] = [
          createElementVNode(
            "section",
            null,
            null,
            -1
            /* CACHED */
          )
        ]), 8, _hoisted_3$2)
      ],
      2112
      /* STABLE_FRAGMENT, DEV_ROOT_FRAGMENT */
    ))
  ]);
}
const TikTokEmbed = /* @__PURE__ */ _export_sfc(_sfc_main$4, [["render", _sfc_render$4], ["__file", "/builds/CT/content-technology-framework/modules/social/editor-ui/src/embeds/tiktok-embed.vue"]]);
const _sfc_main$3 = /* @__PURE__ */ defineComponent({
  __name: "tracdelight-embed",
  props: {
    accessKey: { type: String, required: true, default: "" },
    widgetId: { type: String, required: true, default: "" }
  },
  setup(__props, { expose: __expose }) {
    __expose();
    const props = __props;
    const sharedStore = ref({
      scriptLoaded: false,
      scriptLoading: false
    });
    const html = ref("");
    const generateEmbed = async () => {
      html.value = `<div class="td-widget" data-td-args="{'widget':'${props.widgetId}'}"></div>`;
      await nextTick(() => {
        sharedStore.value.scriptLoading = false;
        sharedStore.value.scriptLoaded = true;
        window.tracdelight.parse();
      });
    };
    const injectScript = () => {
      sharedStore.value.scriptLoading = true;
      const s = document.createElement("script");
      s.defer = true;
      s.src = `https://scripts.tracdelight.io/tracdelight.js?accesskey=${props.accessKey}`;
      s.onload = () => generateEmbed();
      document.body.appendChild(s);
    };
    onMounted(() => {
      injectScript();
    });
    const __returned__ = { props, sharedStore, html, generateEmbed, injectScript };
    Object.defineProperty(__returned__, "__isScriptSetup", { enumerable: false, value: true });
    return __returned__;
  }
});
const _hoisted_1$3 = ["innerHTML"];
function _sfc_render$3(_ctx, _cache, $props, $setup, $data, $options) {
  return openBlock(), createElementBlock("div", null, [
    createCommentVNode(" eslint-disable-next-line vue/no-v-html "),
    createElementVNode("div", {
      class: "tracdelight-embed",
      innerHTML: $setup.html
    }, null, 8, _hoisted_1$3)
  ]);
}
const tracdelightEmbed = /* @__PURE__ */ _export_sfc(_sfc_main$3, [["render", _sfc_render$3], ["__file", "/builds/CT/content-technology-framework/modules/social/editor-ui/src/embeds/tracdelight-embed.vue"]]);
const _sfc_main$2 = /* @__PURE__ */ defineComponent({
  __name: "twitter-embed",
  props: {
    accountName: { type: String, required: true, default: "" },
    tweetId: { type: String, required: true, default: "" }
  },
  setup(__props, { expose: __expose }) {
    __expose();
    const props = __props;
    const sharedStore = ref({
      scriptLoaded: false
    });
    const twitterPostLink = computed(() => {
      return `https://twitter.com/${props.accountName}/status/${props.tweetId}`;
    });
    const loadScript = () => {
      const scriptElem = document.createElement("script");
      scriptElem.src = "https://platform.twitter.com/widgets.js";
      scriptElem.crossOrigin = "anonymous";
      scriptElem.defer = true;
      document.body.appendChild(scriptElem);
      sharedStore.value.scriptLoaded = true;
    };
    onMounted(() => {
      var _a;
      if (sharedStore.value.scriptLoaded && window.twttr) {
        (_a = window.twttr) == null ? void 0 : _a.widgets.load();
      } else {
        loadScript();
      }
    });
    const __returned__ = { props, sharedStore, twitterPostLink, loadScript };
    Object.defineProperty(__returned__, "__isScriptSetup", { enumerable: false, value: true });
    return __returned__;
  }
});
const _hoisted_1$2 = { class: "mb-8" };
const _hoisted_2$2 = { class: "twitter-tweet" };
const _hoisted_3$1 = ["href"];
function _sfc_render$2(_ctx, _cache, $props, $setup, $data, $options) {
  return openBlock(), createElementBlock("div", _hoisted_1$2, [
    createElementVNode("div", null, [
      createElementVNode("blockquote", _hoisted_2$2, [
        createElementVNode("a", { href: $setup.twitterPostLink }, null, 8, _hoisted_3$1)
      ])
    ])
  ]);
}
const TwitterEmbed = /* @__PURE__ */ _export_sfc(_sfc_main$2, [["render", _sfc_render$2], ["__file", "/builds/CT/content-technology-framework/modules/social/editor-ui/src/embeds/twitter-embed.vue"]]);
const _sfc_main$1 = /* @__PURE__ */ defineComponent({
  __name: "youtube-embed",
  props: {
    embedType: { type: String, required: true, default: "" },
    postUrl: { type: String, required: true, default: "" },
    postId: { type: String, required: true, default: "" }
  },
  setup(__props, { expose: __expose }) {
    __expose();
    const __returned__ = {};
    Object.defineProperty(__returned__, "__isScriptSetup", { enumerable: false, value: true });
    return __returned__;
  }
});
const _hoisted_1$1 = { class: "mb-8" };
const _hoisted_2$1 = ["cite", "data-video-id", "data-short-id"];
const _hoisted_3 = ["src"];
function _sfc_render$1(_ctx, _cache, $props, $setup, $data, $options) {
  return openBlock(), createElementBlock("div", _hoisted_1$1, [
    createElementVNode("blockquote", {
      class: normalizeClass($props.embedType === "video" ? "youtube-video" : "youtube-shorts"),
      cite: $props.postUrl,
      "data-video-id": $props.embedType === "video" ? $props.postId : void 0,
      "data-short-id": $props.embedType === "short" ? $props.postId : void 0
    }, [
      createElementVNode("iframe", {
        src: `https://www.youtube.com/embed/${$props.postId}?feature=oembed`,
        style: { "width": "100%", "height": "100%" },
        frameborder: "0",
        referrerpolicy: "strict-origin-when-cross-origin",
        allow: "accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share",
        allowfullscreen: ""
      }, null, 8, _hoisted_3)
    ], 10, _hoisted_2$1)
  ]);
}
const YoutubeEmbed = /* @__PURE__ */ _export_sfc(_sfc_main$1, [["render", _sfc_render$1], ["__file", "/builds/CT/content-technology-framework/modules/social/editor-ui/src/embeds/youtube-embed.vue"]]);
const _sfc_main = /* @__PURE__ */ defineComponent({
  __name: "social-block",
  props: {
    block: { type: Object, required: true, default: void 0 },
    locked: { type: Boolean, required: true, default: false }
  },
  emits: ["update:block"],
  setup(__props, { expose: __expose, emit: __emit }) {
    __expose();
    const emit = __emit;
    const props = __props;
    const { t } = useI18n();
    const { SocialLinkRegExp, SocialLinkValidation } = SocialLinkUtils;
    const localBlock = computed({
      get: () => {
        return props.block;
      },
      set: (block) => {
        emit("update:block", block);
      }
    });
    const socialParagraph = ref("");
    const instagram = ref({ postId: "", postType: "" });
    const twitter = ref({ accountName: "", tweetId: "" });
    const facebook = ref({ postUrl: "", embedType: "" });
    const tiktok = ref({ postUrl: "", postId: "", embedType: "", accountName: "" });
    const youtube = ref({ postUrl: "", embedType: "", postId: "" });
    const tracdelight = ref({ accessKey: "", widgetId: "" });
    const isEmbedVisible = ref(false);
    let toggleEmbed = () => {
      isEmbedVisible.value = !isEmbedVisible.value;
    };
    onMounted(() => {
      toggleEmbed = debounce(toggleEmbed, 350);
    });
    const partialBaseSocialBlock = {
      socialName: "",
      postId: "",
      accountName: "",
      postUrl: "",
      embedType: "",
      accessKey: "",
      widgetId: ""
    };
    const emitSocialParagraphUpdate = (newValues) => {
      const updatedSocialBlock = { ...partialBaseSocialBlock, ...newValues };
      for (const [prop, value] of Object.entries(updatedSocialBlock)) {
        localBlock.value[prop] = value;
      }
    };
    const parseTracdelightParagraph = (data) => {
      const tracdelightMatch = data.match(SocialLinkRegExp.tracdelight);
      if (tracdelightMatch) {
        const accessKey = data.match(/accesskey=([a-zA-Z0-9]{32})/);
        const widgetId = data.match(/'widget':'([a-zA-Z0-9]{16})/);
        tracdelight.value.accessKey = accessKey[1] ?? "";
        tracdelight.value.widgetId = widgetId[1] ?? "";
        emitSocialParagraphUpdate({ socialName: "tracdelight", accessKey: tracdelight.value.accessKey, widgetId: tracdelight.value.widgetId });
      }
    };
    const parseInstagramParagraph = (data) => {
      const idRegex = data.match(SocialLinkRegExp.instagram);
      if (idRegex) {
        const postId = idRegex[2];
        instagram.value.postType = idRegex[1] === "tv" || idRegex[1] === "reel" || idRegex[1] === "p" ? idRegex[1] : "p";
        instagram.value.postId = postId;
        emitSocialParagraphUpdate({ socialName: "instagram", postId });
      } else {
        instagram.value.postType = "p";
      }
    };
    const parseTwitterParagraph = (data) => {
      const twitterOrXMatch = data.match(SocialLinkRegExp.twitter);
      if (twitterOrXMatch) {
        const accountName = twitterOrXMatch[2];
        const postId = twitterOrXMatch[3];
        twitter.value.accountName = accountName;
        twitter.value.tweetId = postId;
        emitSocialParagraphUpdate({ socialName: "twitter", accountName, postId });
      }
    };
    const parseTiktokParagraph = (data) => {
      const urlMatch = data.match(SocialLinkRegExp.tiktok);
      if (urlMatch) {
        const postUrl = urlMatch[0];
        const accountName = urlMatch[1].substring(1);
        const embedType = urlMatch[2];
        const postId = urlMatch[3];
        tiktok.value.postUrl = postUrl;
        tiktok.value.postId = postId;
        tiktok.value.accountName = accountName;
        tiktok.value.embedType = embedType;
        emitSocialParagraphUpdate({ socialName: "tiktok", postUrl, postId, accountName, embedType });
      }
    };
    const parseFacebookParagraph = (data) => {
      const socialName = "facebook";
      const facebookUrlMatch = data.match(SocialLinkRegExp.facebook.postVideo);
      if (facebookUrlMatch) {
        const postUrl = facebookUrlMatch[0];
        const embedType = facebookUrlMatch[1];
        facebook.value.postUrl = postUrl;
        facebook.value.embedType = embedType;
        return emitSocialParagraphUpdate({ socialName, embedType, postUrl });
      }
      const facebookUrlReelMatch = data.match(SocialLinkRegExp.facebook.reel);
      if (facebookUrlReelMatch) {
        const postUrl = facebookUrlReelMatch[0];
        const embedType = "reel";
        facebook.value.postUrl = postUrl;
        facebook.value.embedType = embedType;
        return emitSocialParagraphUpdate({ socialName, embedType, postUrl });
      }
      const facebookUrlPhotoMatch = data.match(SocialLinkRegExp.facebook.photo);
      if (facebookUrlPhotoMatch) {
        const postUrl = facebookUrlPhotoMatch[0];
        const embedType = "posts";
        facebook.value.postUrl = postUrl;
        facebook.value.embedType = embedType;
        return emitSocialParagraphUpdate({ socialName, embedType, postUrl });
      }
      const facebookPostMatch = data.match(SocialLinkRegExp.facebook.embedPost);
      if (facebookPostMatch) {
        const postUrl = decodeURIComponent(facebookPostMatch[1]);
        const embedType = "posts";
        facebook.value.postUrl = postUrl;
        facebook.value.embedType = embedType;
        return emitSocialParagraphUpdate({ socialName, embedType, postUrl });
      }
      const facebookVideoMatch = data.match(SocialLinkRegExp.facebook.embedVideo);
      if (facebookVideoMatch) {
        const embedType = "videos";
        const postUrl = decodeURIComponent(facebookVideoMatch[1]);
        facebook.value.postUrl = postUrl;
        facebook.value.embedType = embedType;
        return emitSocialParagraphUpdate({ socialName, embedType, postUrl });
      }
    };
    const parseYoutubeParagraph = (data) => {
      const youtubeVideoMatch = data.match(SocialLinkRegExp.youtube.video);
      if (youtubeVideoMatch) {
        const postUrl = `https://www.youtube.com/watch?v=${youtubeVideoMatch[1]}`;
        const embedType = "video";
        const postId = youtubeVideoMatch[1];
        youtube.value.postUrl = postUrl;
        youtube.value.embedType = embedType;
        youtube.value.postId = postId;
        return emitSocialParagraphUpdate({ socialName: "youtube", embedType, postUrl, postId });
      }
      const youtubeEmbedMatch = data.match(SocialLinkRegExp.youtube.embed);
      if (youtubeEmbedMatch) {
        const postUrl = `https://www.youtube.com/watch?v=${youtubeEmbedMatch[1]}`;
        const embedType = "video";
        const postId = youtubeEmbedMatch[1];
        youtube.value.postUrl = postUrl;
        youtube.value.embedType = embedType;
        youtube.value.postId = postId;
        return emitSocialParagraphUpdate({ socialName: "youtube", embedType, postUrl, postId });
      }
      const youtubeShortsMatch = data.match(SocialLinkRegExp.youtube.short);
      if (youtubeShortsMatch) {
        const postUrl = `https://www.youtube.com/shorts/${youtubeShortsMatch[1]}`;
        const embedType = "short";
        const postId = youtubeShortsMatch[1];
        youtube.value.postUrl = postUrl;
        youtube.value.embedType = embedType;
        youtube.value.postId = postId;
        return emitSocialParagraphUpdate({ socialName: "youtube", embedType, postUrl, postId });
      }
    };
    const emptySocialParagraph = () => {
      socialParagraph.value = "";
      instagram.value = { postId: "", postType: "" };
      twitter.value = { accountName: "", tweetId: "" };
      facebook.value = { postUrl: "", embedType: "" };
      tiktok.value = { postUrl: "", postId: "", embedType: "", accountName: "" };
      youtube.value = { postUrl: "", embedType: "", postId: "" };
      localBlock.value.socialName = "";
      localBlock.value.postId = "";
      delete localBlock.value.accountName;
      delete localBlock.value.postUrl;
      delete localBlock.value.embedType;
    };
    const defineSocialParagraph = (content) => {
      if (SocialLinkValidation.isInstagram(content)) {
        socialParagraph.value = "instagram";
        parseInstagramParagraph(content);
      } else if (SocialLinkValidation.isTwitter(content)) {
        socialParagraph.value = "twitter";
        parseTwitterParagraph(content);
      } else if (SocialLinkValidation.isTiktok(content)) {
        socialParagraph.value = "tiktok";
        parseTiktokParagraph(content);
      } else if (SocialLinkValidation.isFacebook(content)) {
        socialParagraph.value = "facebook";
        parseFacebookParagraph(content);
      } else if (SocialLinkValidation.isYoutube(content)) {
        socialParagraph.value = "youtube";
        parseYoutubeParagraph(content);
      } else if (SocialLinkValidation.isTracdelight(content)) {
        socialParagraph.value = "tracdelight";
        parseTracdelightParagraph(content);
      } else {
        emptySocialParagraph();
      }
    };
    const forceEmbedReload = () => {
      isEmbedVisible.value = false;
    };
    const changeBlockSocial = (content) => {
      defineSocialParagraph(content);
    };
    watchEffect(() => {
      changeBlockSocial(localBlock.value.content);
      nextTick(() => isEmbedVisible.value = localBlock.value.socialName !== "");
      forceEmbedReload();
    });
    const __returned__ = { emit, props, t, SocialLinkRegExp, SocialLinkValidation, localBlock, socialParagraph, instagram, twitter, facebook, tiktok, youtube, tracdelight, isEmbedVisible, get toggleEmbed() {
      return toggleEmbed;
    }, set toggleEmbed(v) {
      toggleEmbed = v;
    }, partialBaseSocialBlock, emitSocialParagraphUpdate, parseTracdelightParagraph, parseInstagramParagraph, parseTwitterParagraph, parseTiktokParagraph, parseFacebookParagraph, parseYoutubeParagraph, emptySocialParagraph, defineSocialParagraph, forceEmbedReload, changeBlockSocial, get QBtn() {
      return QBtn;
    }, get QIcon() {
      return QIcon;
    }, get QInput() {
      return QInput;
    }, FacebookEmbed, InstagramEmbed, PlaceholderEmbed, TikTokEmbed, tracdelightEmbed, TwitterEmbed, YoutubeEmbed };
    Object.defineProperty(__returned__, "__isScriptSetup", { enumerable: false, value: true });
    return __returned__;
  }
});
const _hoisted_1 = { class: "q-ml-sm" };
const _hoisted_2 = {
  key: 0,
  class: "row justify-center q-mt-sm"
};
function _sfc_render(_ctx, _cache, $props, $setup, $data, $options) {
  return openBlock(), createElementBlock("div", null, [
    createVNode($setup["QInput"], {
      modelValue: $setup.localBlock.content,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => $setup.localBlock.content = $event),
      disabled: $props.locked,
      type: "textarea",
      filled: "",
      placeholder: $setup.t("social.socialScriptBlock"),
      rows: "3",
      outlined: ""
    }, null, 8, ["modelValue", "disabled", "placeholder"]),
    createVNode($setup["QBtn"], {
      outline: "",
      color: "black",
      class: "q-mt-md q-mb-sm",
      disable: !$setup.localBlock.socialName,
      onClick: $setup.toggleEmbed
    }, {
      default: withCtx(() => [
        !$setup.isEmbedVisible ? (openBlock(), createBlock($setup["QIcon"], {
          key: 0,
          color: "primary",
          name: "eye"
        })) : $setup.isEmbedVisible ? (openBlock(), createBlock($setup["QIcon"], {
          key: 1,
          color: "primary",
          name: "eye-off"
        })) : createCommentVNode("v-if", true),
        createElementVNode(
          "span",
          _hoisted_1,
          toDisplayString($setup.isEmbedVisible ? $setup.t("social.hideEmbed") : $setup.t("social.showEmbed")),
          1
          /* TEXT */
        )
      ]),
      _: 1
      /* STABLE */
    }, 8, ["disable", "onClick"]),
    $setup.isEmbedVisible ? (openBlock(), createElementBlock("div", _hoisted_2, [
      $setup.socialParagraph === "instagram" ? (openBlock(), createBlock($setup["InstagramEmbed"], {
        key: 0,
        "post-id": $setup.instagram.postId,
        "post-type": $setup.instagram.postType
      }, null, 8, ["post-id", "post-type"])) : $setup.socialParagraph === "twitter" ? (openBlock(), createBlock($setup["TwitterEmbed"], {
        key: 1,
        "account-name": $setup.twitter.accountName,
        "tweet-id": $setup.twitter.tweetId
      }, null, 8, ["account-name", "tweet-id"])) : $setup.socialParagraph === "facebook" && $setup.isEmbedVisible ? (openBlock(), createBlock($setup["FacebookEmbed"], {
        key: 2,
        "embed-type": $setup.facebook.embedType,
        "post-url": $setup.facebook.postUrl
      }, null, 8, ["embed-type", "post-url"])) : $setup.socialParagraph === "tiktok" ? (openBlock(), createBlock($setup["TikTokEmbed"], {
        key: 3,
        "post-url": $setup.tiktok.postUrl,
        "post-id": $setup.tiktok.postId,
        "embed-type": $setup.tiktok.embedType,
        "account-name": $setup.tiktok.accountName
      }, null, 8, ["post-url", "post-id", "embed-type", "account-name"])) : $setup.socialParagraph === "youtube" ? (openBlock(), createBlock($setup["YoutubeEmbed"], {
        key: 4,
        "post-url": $setup.youtube.postUrl,
        "embed-type": $setup.youtube.embedType,
        "post-id": $setup.youtube.postId
      }, null, 8, ["post-url", "embed-type", "post-id"])) : $setup.socialParagraph === "tracdelight" ? (openBlock(), createBlock($setup["tracdelightEmbed"], {
        key: 5,
        "access-key": $setup.tracdelight.accessKey,
        "widget-id": $setup.tracdelight.widgetId
      }, null, 8, ["access-key", "widget-id"])) : (openBlock(), createBlock($setup["PlaceholderEmbed"], {
        key: 6,
        class: "placeholder-embed"
      }))
    ])) : createCommentVNode("v-if", true)
  ]);
}
const SocialBlock = /* @__PURE__ */ _export_sfc(_sfc_main, [["render", _sfc_render], ["__scopeId", "data-v-3e88e2d1"], ["__file", "/builds/CT/content-technology-framework/modules/social/editor-ui/src/blocks/social-block.vue"]]);
const de = {
  social: {
    socialScriptBlock: "Social-Script einfügen",
    socialNotSupported: "Dieser Social Block wird nicht unterstützt",
    showEmbed: "Embed anzeigen",
    hideEmbed: "Embed verstecken",
    contentBlockLabel: "Social"
  }
};
const en = {
  social: {
    socialScriptBlock: "Insert social script",
    socialNotSupported: "This social block is not supported",
    showEmbed: "Show embed",
    hideEmbed: "Hide embed",
    contentBlockLabel: "Social"
  }
};
const messages = { en, de };
const socialModule = {
  messages,
  routes: [],
  contentBlocks: [
    {
      type: "SOCIAL",
      label: "social.contentBlockLabel",
      icon: "instagram",
      component: SocialBlock,
      defaultValue: { type: "SOCIAL", content: "", socialName: "", postId: "" }
    }
  ]
};
export {
  socialModule
};
//# sourceMappingURL=index.es.js.map
